import type { SearchCatalogItemsQuery } from "@albertine/types/openapi/lmt";
import { hasAllBoundingBoxParams } from "@/common/CatalogItem";

export type LatLng = { lat: number; lng: number };

export function centerOfBounds(
    query: SearchCatalogItemsQuery | undefined,
): LatLng | undefined {
    if (!query) return undefined;
    if (!hasAllBoundingBoxParams(query)) return undefined;
    return {
        lat: (query.geoBoundingBoxTop + query.geoBoundingBoxBottom) / 2,
        lng: (query.geoBoundingBoxLeft + query.geoBoundingBoxRight) / 2,
    };
}

export function getSearchLocation(
    query: SearchCatalogItemsQuery | undefined,
): LatLng | undefined {
    if (!query) return undefined;
    if (query.latitude == null || query.longitude == null) return undefined;
    return { lat: query.latitude, lng: query.longitude };
}

export function getDistanceOrigin(
    query: SearchCatalogItemsQuery | undefined,
): LatLng | undefined {
    return centerOfBounds(query) ?? getSearchLocation(query);
}
